import { render, staticRenderFns } from "./EntityAdministration.vue?vue&type=template&id=aafcd1d2"
import script from "./EntityAdministration.vue?vue&type=script&lang=js"
export * from "./EntityAdministration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports